import EventHeadline from './EventHeadline';

export default EventHeadline;
